import { ActivatedRoute } from '@angular/router';
import { Component, inject, OnInit } from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { Observable, timer, of } from 'rxjs';
import { switchMap, catchError, tap, shareReplay } from 'rxjs/operators';

import { TasksService } from '../../../services/tasks.service';
import { fadeInOutAnimation } from '../../../../../helpers/reusableAnimations';

@Component({
    selector: 'app-tasks-index',
    templateUrl: './tasks-index.component.html',
    styleUrls: ['./tasks-index.component.scss'],
    animations: [fadeInOutAnimation],
})
export class TasksIndexComponent implements OnInit {

    private readonly service = inject(TasksService);
    private readonly toastr = inject(ToastrService);
    public readonly route = inject(ActivatedRoute);

    activeTab = 'downloads';
    queryParams$ = this.route.queryParams;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    importJobs$: Observable<any>;
    importJobsError: boolean;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportJobs$: Observable<any>;
    exportJobsError: boolean;

    ngOnInit() {
        const polling$ = timer(1, 30e3).pipe(
            shareReplay({ bufferSize: 1, refCount: true })
        );

        this.exportJobs$ = polling$.pipe(
            tap(() => (this.exportJobsError = false)),
            switchMap(() => this.service.getExportJobs()),
            catchError(() => {
                this.exportJobsError = true;
                return of([]);
            })
        );

        this.importJobs$ = polling$.pipe(
            tap(() => (this.importJobsError = false)),
            switchMap(() => this.service.getImportJobs()),
            catchError(() => {
                this.importJobsError = true;
                return of([]);
            })
        );
    }

    public downloadExportJob(exportJob: { id: number; downloading: boolean; }) {
        exportJob.downloading = true;
        const downloadSubscription = this.service
            .getExportJobDownloadLink(exportJob.id)
            .subscribe({
                next: result => {
                    window.open(result.url, 'blank');
                    exportJob.downloading = false;
                    downloadSubscription.unsubscribe();
                },
                error: () => {
                    exportJob.downloading = false;
                    downloadSubscription.unsubscribe();
                    this.toastr.error(
                        'Please try again or contact support if the problem persists',
                        // tslint:disable-next-line: quotemark
                        "We're sorry, something went wrong downloading your routing guide."
                    );
                }
            });
    }
}
